"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnergyTapping = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const DecreaseAnyProduction_1 = require("../../deferredActions/DecreaseAnyProduction");
const CardRenderer_1 = require("../render/CardRenderer");
class EnergyTapping extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.ENERGY_TAPPING,
            tags: [Tags_1.Tags.ENERGY],
            cost: 3,
            metadata: {
                cardNumber: '201',
                description: 'Decrease any Energy production 1 step and increase your own 1 step.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.minus().energy(1).any.br;
                        pb.plus().energy(1);
                    });
                }),
                victoryPoints: -1,
            },
        });
    }
    canPlay(player) {
        const otherPlayersHaveEnergyProduction = player.game.isSoloMode() || player.game.getPlayers().filter((p) => p.getProduction(Resources_1.Resources.ENERGY) > 0 && p.id !== player.id).length > 0;
        Card_1.Card.setProductionDecreaseWarningText(this, Resources_1.Resources.ENERGY, otherPlayersHaveEnergyProduction);
        return true;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        player.game.defer(new DecreaseAnyProduction_1.DecreaseAnyProduction(player, Resources_1.Resources.ENERGY, 1));
        return undefined;
    }
    getVictoryPoints() {
        return -1;
    }
}
exports.EnergyTapping = EnergyTapping;
//# sourceMappingURL=EnergyTapping.js.map